export default "__VITE_ASSET__b4c9d286__"